/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _init = __webpack_require__(1);
	
	var _init2 = _interopRequireDefault(_init);
	
	var _header = __webpack_require__(31);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _popup = __webpack_require__(32);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import staffPortal from './pages/staff-portal';
	(0, _init2.default)();
	(0, _header2.default)();
	(0, _popup2.default)();
	// staffPortal();

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = init;
	
	var _links = __webpack_require__(2);
	
	var _links2 = _interopRequireDefault(_links);
	
	var _tracking = __webpack_require__(4);
	
	var _tracking2 = _interopRequireDefault(_tracking);
	
	var _scroller = __webpack_require__(5);
	
	var _scroller2 = _interopRequireDefault(_scroller);
	
	var _toggler = __webpack_require__(7);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	var _tracker = __webpack_require__(11);
	
	var _tracker2 = _interopRequireDefault(_tracker);
	
	var _autosize = __webpack_require__(12);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	var _floatLabel = __webpack_require__(14);
	
	var _floatLabel2 = _interopRequireDefault(_floatLabel);
	
	var _validator = __webpack_require__(15);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _recaptcha = __webpack_require__(17);
	
	var _recaptcha2 = _interopRequireDefault(_recaptcha);
	
	var _lightbox = __webpack_require__(18);
	
	var _lightbox2 = _interopRequireDefault(_lightbox);
	
	var _map = __webpack_require__(20);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _playOnHover = __webpack_require__(21);
	
	var _playOnHover2 = _interopRequireDefault(_playOnHover);
	
	var _swiper = __webpack_require__(22);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	var _fade = __webpack_require__(23);
	
	var _fade2 = _interopRequireDefault(_fade);
	
	var _lazyLoad = __webpack_require__(25);
	
	var _lazyLoad2 = _interopRequireDefault(_lazyLoad);
	
	var _parallax = __webpack_require__(27);
	
	var _parallax2 = _interopRequireDefault(_parallax);
	
	var _reveal = __webpack_require__(28);
	
	var _reveal2 = _interopRequireDefault(_reveal);
	
	var _sticky = __webpack_require__(30);
	
	var _sticky2 = _interopRequireDefault(_sticky);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function init() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    (0, _links2.default)(context);
	    (0, _tracking2.default)(context);
	    (0, _scroller2.default)(context);
	    (0, _toggler2.default)(context);
	    (0, _tracker2.default)(context);
	    (0, _autosize2.default)(context);
	    (0, _floatLabel2.default)(context);
	    (0, _validator2.default)(context);
	    (0, _recaptcha2.default)(context);
	    (0, _lightbox2.default)(context);
	    (0, _map2.default)(context);
	    (0, _playOnHover2.default)(context);
	    (0, _swiper2.default)(context);
	    (0, _fade2.default)(context);
	    (0, _lazyLoad2.default)(context);
	    (0, _parallax2.default)(context);
	    (0, _reveal2.default)(context);
	    (0, _sticky2.default)(context);
	}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = linksEnhancement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assetExtensions = 'png jpg jpeg gif doc docx xls xlsx pdf ppt pptx'.split(' ');
	
	/**
	 * Improves the functionality of links depending on their URL's.
	 *
	 * @param context
	 */
	function linksEnhancement() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('a').each(function () {
	        var $a = (0, _jquery2.default)(this);
	        var href = String($a.attr('href'));
	
	        // Animates scroll for anchor links
	        if (href.startsWith('#')) {
	            $a.attr('sw-scroller', JSON.stringify({ to: href }));
	        }
	
	        // Forces new window clicks for asset files
	        var lowerHref = href.toLowerCase();
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	            for (var _iterator = assetExtensions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var ext = _step.value;
	
	                if (lowerHref.endsWith('.' + ext)) {
	                    $a.attr('target', '_blank');
	                    break;
	                }
	            }
	        } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                }
	            } finally {
	                if (_didIteratorError) {
	                    throw _iteratorError;
	                }
	            }
	        }
	    });
	
	    // Force no focusing on links just clicked. This ensures no focus outline shows up after clicking.
	    $context.find('a, button').on('click', function () {
	        (0, _jquery2.default)(this).trigger('blur');
	    });
	}

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = trackingEnhancement;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enables automatic tracking on links and forms.
	 *
	 * @param context
	 */
	function trackingEnhancement() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		var trackingElements = [{ selector: 'a[href^="mailto:"]', label: "Email click" }, { selector: 'a[href^="tel:"]', label: "Phone click" }, { selector: 'form', label: "Form sent" }];
	
		trackingElements.forEach(function (_ref) {
			var selector = _ref.selector,
			    label = _ref.label;
	
			$context.find(selector).attr('sw-tracker', JSON.stringify({ label: label }));
		});
	}

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = scrollerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $body = (0, _jquery2.default)('html, body');
	var docEl = document.documentElement;
	
	var breakable = true;
	var breakTimeout = null;
	var bound = false;
	
	/**
	 * Scrolls to a point on the page when an element is clicked.
	 *
	 * Scrolls to top: <button sw-scroller="top">Top</button>
	 * Scrolls to bottom: <button sw-scroller="bottom">Bottom</button>
	 * Scrolls to element by ID: <button sw-scroller="#element">Element</button>
	 *
	 * @param context
	 */
	function scrollerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-scroller]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-scroller');
	        var settings = (0, _parse.directiveSettings)(json, {
	            to: 'top',
	            selector: null,
	            speed: 500
	        }, 'to');
	
	        $element.on('click', function (e) {
	            e.preventDefault();
	
	            clearInterval(breakTimeout);
	            breakable = false;
	            breakTimeout = setTimeout(function () {
	                return breakable = true;
	            }, 100);
	
	            var top = 0;
	            switch (settings.to) {
	                case 'top':
	                    top = 0;break;
	                case 'bottom':
	                    top = docEl.scrollHeight - docEl.clientHeight;break;
	                case 'element':
	                    top = (0, _jquery2.default)(settings.selector).offset().top;break;
	                default:
	                    top = (0, _jquery2.default)(settings.to).offset().top;
	            }
	
	            $body.animate({ scrollTop: Math.min(top, docEl.scrollHeight - docEl.clientHeight) }, { duration: settings.speed });
	        });
	    });
	
	    if (!bound) {
	        bound = true;
	        $body.bind('scroll mousedown DOMMouseScroll mousewheel keyup touchstart', function (e) {
	            if (breakable && e.which > 0) {
	                switch (e.type) {
	                    case 'mousedown':
	                    case 'mousewheel':
	                    case 'touchstart':
	                        $body.stop();break;
	                }
	            }
	        });
	    }
	}

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.directiveSettings = directiveSettings;
	/**
	 * Parses the JSON from a directive.
	 *
	 * @param data
	 * @param defaults
	 * @param targetProperty
	 */
	function directiveSettings(data) {
	    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var targetProperty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	    var settings = Object.assign({}, defaults);
	
	    if (data) {
	        var parsedData = void 0;
	
	        try {
	            parsedData = JSON.parse(data);
	        } catch (e) {
	            parsedData = data;
	        }
	
	        if (parsedData instanceof Object && !Array.isArray(parsedData)) {
	            Object.assign(settings, parsedData);
	        } else if (targetProperty) {
	            settings[targetProperty] = parsedData;
	        } else {
	            console.error("Error parsing settings: \"" + data + "\"");
	        }
	    }
	
	    return settings;
	}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = togglerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _toggler = __webpack_require__(8);
	
	var _toggler2 = _interopRequireDefault(_toggler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Toggles the visual display of an element on the page.
	 * Contains action directives for interacting with a toggler element:
	 *  - toggler-open
	 *  - toggler-close
	 *  - toggler-toggle
	 *
	 * @param context
	 */
	function togglerDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-toggler]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler');
	        var settings = (0, _parse.directiveSettings)(json, {
	            open: true,
	            transition: false
	        }, 'open');
	
	        var toggler = new _toggler2.default(this, settings);
	
	        $element.data('toggler', toggler);
	    });
	
	    var _arr = ['open', 'close', 'toggle'];
	
	    var _loop = function _loop() {
	        var action = _arr[_i];
	
	        $context.find('[sw-toggler-' + action + ']').each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-toggler-' + action);
	            var settings = (0, _parse.directiveSettings)(json, {
	                target: null,
	                on: 'click',
	                prevent: true
	            }, 'target');
	
	            $element.on(settings.on, function (e) {
	                var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	                var toggler = $target.data('toggler');
	
	                if (toggler) {
	                    toggler[action]();
	                }
	
	                if (settings.prevent) {
	                    e.preventDefault();
	                }
	            });
	        });
	    };
	
	    for (var _i = 0; _i < _arr.length; _i++) {
	        _loop();
	    }
	
	    $context.find('[sw-toggler-class]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-toggler-class');
	        var settings = (0, _parse.directiveSettings)(json, {
	            target: null,
	            openClass: 'is-open',
	            closedClass: 'is-closed'
	        }, 'target');
	
	        var $target = settings.target ? (0, _jquery2.default)(settings.target) : $element.closest('[sw-toggler]');
	        var toggler = $target.data('toggler');
	
	        if (toggler) {
	            var updateClasses = function updateClasses() {
	                $element.removeClass(toggler.isOpen ? settings.closedClass : settings.openClass);
	                $element.addClass(toggler.isOpen ? settings.openClass : settings.closedClass);
	            };
	
	            toggler.on('toggle', updateClasses);
	            updateClasses();
	        }
	    });
	}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.transitionTypes = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _emitter = __webpack_require__(9);
	
	var _emitter2 = _interopRequireDefault(_emitter);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Map of transition types.
	 */
	var transitionTypes = exports.transitionTypes = {
	
	    css: {
	        init: function init(toggler) {
	            toggler.$element[0].addEventListener('transitionend', function (e) {
	                if (e.target === toggler.$element[0]) {
	                    toggler.transitionEnd();
	                }
	            });
	        }
	    },
	
	    height: {
	        init: function init(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        },
	        start: function start(toggler) {
	            if (toggler.isOpen) {
	                toggler.$element.slideDown(300, function () {
	                    return toggler.transitionEnd();
	                });
	            } else {
	                toggler.$element.slideUp(300, function () {
	                    return toggler.transitionEnd();
	                });
	            }
	        },
	        skip: function skip(toggler) {
	            toggler.$element.css('display', toggler.isOpen ? '' : 'none');
	        }
	    }
	};
	
	/**
	 * Toggler class for toggling the visual state of an element.
	 */
	
	var Toggler = function (_Emitter) {
	    _inherits(Toggler, _Emitter);
	
	    /**
	     *
	     * @param element
	     * @param settings
	     */
	    function Toggler(element) {
	        var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _classCallCheck(this, Toggler);
	
	        var _this = _possibleConstructorReturn(this, (Toggler.__proto__ || Object.getPrototypeOf(Toggler)).call(this));
	
	        _this.$element = (0, _jquery2.default)(element);
	        _this.isOpen = typeof settings.open === 'boolean' ? settings.open : true;
	        _this.transition = settings.transition in transitionTypes ? settings.transition : false;
	
	        _this.transitionInit();
	        return _this;
	    }
	
	    /**
	     *
	     * @param isOpen
	     * @param transition
	     */
	
	
	    _createClass(Toggler, [{
	        key: 'toggle',
	        value: function toggle(isOpen, transition) {
	            isOpen = typeof isOpen === 'boolean' ? isOpen : !this.isOpen;
	            transition = typeof transition === 'boolean' ? transition : true;
	
	            if (this.isOpen !== isOpen) {
	                this.isOpen = isOpen;
	
	                if (this.transition && transition) {
	
	                    this.transitionStart();
	                } else {
	
	                    this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	                    this.transitionSkip();
	                }
	
	                this.trigger('toggle');
	                this.trigger(this.isOpen ? 'open' : 'close');
	            }
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'open',
	        value: function open(transition) {
	            this.toggle(true, transition);
	        }
	
	        /**
	         *
	         * @param transition
	         */
	
	    }, {
	        key: 'close',
	        value: function close(transition) {
	            this.toggle(false, transition);
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionInit',
	        value: function transitionInit() {
	            this.$element.removeClass('is-before-opening is-opening is-before-closing is-closing').toggleClass('is-open', this.isOpen).toggleClass('is-closed', !this.isOpen);
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.init) {
	                transitionType.init(this);
	            }
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionStart',
	        value: function transitionStart() {
	
	            if (this.isOpen) {
	
	                if (this.$element.hasClass('is-before-closing')) {
	
	                    this.$element.removeClass('is-before-closing').addClass('is-open');
	                } else if (this.$element.hasClass('is-closing')) {
	
	                    this.$element.removeClass('is-before-closing is-closing').addClass('is-opening');
	                } else {
	
	                    this.$element.removeClass('is-closed').addClass('is-before-opening');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-opening').addClass('is-opening');
	                }
	            } else {
	
	                if (this.$element.hasClass('is-before-opening')) {
	
	                    this.$element.removeClass('is-before-opening').addClass('is-closed');
	                } else if (this.$element.hasClass('is-opening')) {
	
	                    this.$element.removeClass('is-opening').addClass('is-closing');
	                } else {
	
	                    this.$element.removeClass('is-open').addClass('is-before-closing');
	
	                    (0, _drawing.redraw)(this.$element);
	
	                    this.$element.removeClass('is-before-closing').addClass('is-closing');
	                }
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.start) {
	                transitionType.start(this);
	            }
	
	            this.trigger('transitionStart');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionEnd',
	        value: function transitionEnd() {
	            if (this.isOpen) {
	
	                this.$element.removeClass('is-opening').addClass('is-open');
	            } else {
	
	                this.$element.removeClass('is-closing').addClass('is-closed');
	            }
	
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.end) {
	                transitionType.end(this);
	            }
	
	            this.trigger('transitionEnd');
	        }
	
	        /**
	         *
	         */
	
	    }, {
	        key: 'transitionSkip',
	        value: function transitionSkip() {
	            var transitionType = transitionTypes[this.transition];
	            if (transitionType && transitionType.skip) {
	                transitionType.skip(this);
	            }
	        }
	    }]);
	
	    return Toggler;
	}(_emitter2.default);
	
	exports.default = Toggler;

/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Emitter = function () {
	    function Emitter() {
	        _classCallCheck(this, Emitter);
	
	        this.events = {};
	    }
	
	    _createClass(Emitter, [{
	        key: "on",
	        value: function on(type, callback) {
	            if (!(type in this.events)) {
	                this.events[type] = [];
	            }
	            this.events[type].push(callback);
	        }
	    }, {
	        key: "off",
	        value: function off(type) {
	            var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	            if (callback && type in this.events) {
	                var newList = [];
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.events[type][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var cb = _step.value;
	
	                        if (cb !== callback) {
	                            newList.push(cb);
	                        }
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	
	                this.events[type] = newList;
	            } else {
	                delete this.events[type];
	            }
	        }
	    }, {
	        key: "trigger",
	        value: function trigger(type) {
	            var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	            if (type in this.events) {
	                event.type = type;
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                    for (var _iterator2 = this.events[type][Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                        var cb = _step2.value;
	
	                        cb.call(this, event);
	                    }
	                } catch (err) {
	                    _didIteratorError2 = true;
	                    _iteratorError2 = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                            _iterator2.return();
	                        }
	                    } finally {
	                        if (_didIteratorError2) {
	                            throw _iteratorError2;
	                        }
	                    }
	                }
	            }
	        }
	    }]);
	
	    return Emitter;
	}();
	
	exports.default = Emitter;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.frame = frame;
	exports.unframe = unframe;
	exports.redraw = redraw;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Requests an animation frame.
	 *
	 * @param callback
	 * @returns {*}
	 */
	function frame(callback) {
	    if (typeof requestAnimationFrame === 'undefined') {
	        return setTimeout(callback, 0);
	    }
	    return requestAnimationFrame(callback);
	}
	
	/**
	 * Cancels a frame request.
	 *
	 * @param id
	 */
	function unframe(id) {
	    if (typeof cancelAnimationFrame === 'undefined') {
	        return clearTimeout(id);
	    }
	    return cancelAnimationFrame(id);
	}
	
	/**
	 * Triggers a layout reflow for a specific element.
	 *
	 * @param element
	 */
	function redraw(element) {
	    if (element instanceof _jquery2.default) {
	        element = element[0];
	    }
	    // Accessing this property triggers a layout reflow
	    element.offsetWidth;
	}

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = trackerDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param type
	 * @param action
	 * @param label
	 * @param timeout
	 * @returns {*}
	 */
	function trackEvent() {
		var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'lead';
		var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'click';
		var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
		var timeout = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;
	
		var promises = [];
	
		// Google Analytics
		if (typeof ga === 'function') {
	
			promises.push(new Promise(function (resolve, reject) {
	
				ga('send', {
					hitType: 'event',
					eventCategory: type,
					eventAction: action,
					eventLabel: label,
					hitCallback: function hitCallback() {
						return resolve();
					}
				});
	
				setTimeout(function () {
					return reject();
				}, timeout);
			}));
		}
	
		// Facebook Pixel
		if (typeof fqb === 'function') {
	
			promises.push(new Promise(function (resolve, reject) {
	
				fbq('track', 'Lead');
				resolve();
	
				// Facebook Pixel has no callback...
				// setTimeout(() => reject(), timeout);
			}));
		}
	
		return Promise.all(promises);
	}
	
	/**
	 *
	 * @param context
	 */
	function trackerDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
	
		$context.find('[sw-tracker]').each(function () {
			var _this = this;
	
			var $element = (0, _jquery2.default)(this);
			var json = $element.attr('sw-tracker');
			var settings = (0, _parse.directiveSettings)(json, {
				on: 'auto',
				type: 'lead',
				label: '',
				timeout: 1000
			}, 'label');
	
			if (settings.on === 'auto') {
				if ($element.is('form')) {
					settings.on = 'submit';
				} else {
					settings.on = 'click';
				}
			}
	
			$element.on(settings.on + '.tracker', function (e) {
				e.preventDefault();
				e.stopImmediatePropagation();
	
				var trigger = function trigger() {
					$element.off('.tracker');
					$element.trigger(settings.on);
	
					if (settings.on === 'click' && $element.is('a[href]')) {
						_this.click();
					}
				};
	
				trackEvent(settings.type, settings.on, settings.label, settings.timeout).then(trigger).catch(trigger);
			});
		});
	}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = autosizeDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(13);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Enhances textarea fields by automatically expanding it's height to fit it's contents.
	 *
	 * @see https://github.com/jackmoore/autosize
	 * @param context
	 */
	function autosizeDirective() {
	  var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	  var $context = (0, _jquery2.default)(context);
	  (0, _autosize2.default)($context.find('textarea[sw-autosize]'));
	}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
		Autosize 3.0.21
		license: MIT
		http://www.jacklmoore.com/autosize
	*/
	(function (global, factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
			factory(exports, module);
		} else {
			var mod = {
				exports: {}
			};
			factory(mod.exports, mod);
			global.autosize = mod.exports;
		}
	})(this, function (exports, module) {
		'use strict';
	
		var map = typeof Map === "function" ? new Map() : (function () {
			var keys = [];
			var values = [];
	
			return {
				has: function has(key) {
					return keys.indexOf(key) > -1;
				},
				get: function get(key) {
					return values[keys.indexOf(key)];
				},
				set: function set(key, value) {
					if (keys.indexOf(key) === -1) {
						keys.push(key);
						values.push(value);
					}
				},
				'delete': function _delete(key) {
					var index = keys.indexOf(key);
					if (index > -1) {
						keys.splice(index, 1);
						values.splice(index, 1);
					}
				}
			};
		})();
	
		var createEvent = function createEvent(name) {
			return new Event(name, { bubbles: true });
		};
		try {
			new Event('test');
		} catch (e) {
			// IE does not support `new Event()`
			createEvent = function (name) {
				var evt = document.createEvent('Event');
				evt.initEvent(name, true, false);
				return evt;
			};
		}
	
		function assign(ta) {
			if (!ta || !ta.nodeName || ta.nodeName !== 'TEXTAREA' || map.has(ta)) return;
	
			var heightOffset = null;
			var clientWidth = ta.clientWidth;
			var cachedHeight = null;
	
			function init() {
				var style = window.getComputedStyle(ta, null);
	
				if (style.resize === 'vertical') {
					ta.style.resize = 'none';
				} else if (style.resize === 'both') {
					ta.style.resize = 'horizontal';
				}
	
				if (style.boxSizing === 'content-box') {
					heightOffset = -(parseFloat(style.paddingTop) + parseFloat(style.paddingBottom));
				} else {
					heightOffset = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
				}
				// Fix when a textarea is not on document body and heightOffset is Not a Number
				if (isNaN(heightOffset)) {
					heightOffset = 0;
				}
	
				update();
			}
	
			function changeOverflow(value) {
				{
					// Chrome/Safari-specific fix:
					// When the textarea y-overflow is hidden, Chrome/Safari do not reflow the text to account for the space
					// made available by removing the scrollbar. The following forces the necessary text reflow.
					var width = ta.style.width;
					ta.style.width = '0px';
					// Force reflow:
					/* jshint ignore:start */
					ta.offsetWidth;
					/* jshint ignore:end */
					ta.style.width = width;
				}
	
				ta.style.overflowY = value;
			}
	
			function getParentOverflows(el) {
				var arr = [];
	
				while (el && el.parentNode && el.parentNode instanceof Element) {
					if (el.parentNode.scrollTop) {
						arr.push({
							node: el.parentNode,
							scrollTop: el.parentNode.scrollTop
						});
					}
					el = el.parentNode;
				}
	
				return arr;
			}
	
			function resize() {
				var originalHeight = ta.style.height;
				var overflows = getParentOverflows(ta);
				var docTop = document.documentElement && document.documentElement.scrollTop; // Needed for Mobile IE (ticket #240)
	
				ta.style.height = 'auto';
	
				var endHeight = ta.scrollHeight + heightOffset;
	
				if (ta.scrollHeight === 0) {
					// If the scrollHeight is 0, then the element probably has display:none or is detached from the DOM.
					ta.style.height = originalHeight;
					return;
				}
	
				ta.style.height = endHeight + 'px';
	
				// used to check if an update is actually necessary on window.resize
				clientWidth = ta.clientWidth;
	
				// prevents scroll-position jumping
				overflows.forEach(function (el) {
					el.node.scrollTop = el.scrollTop;
				});
	
				if (docTop) {
					document.documentElement.scrollTop = docTop;
				}
			}
	
			function update() {
				resize();
	
				var styleHeight = Math.round(parseFloat(ta.style.height));
				var computed = window.getComputedStyle(ta, null);
	
				// Using offsetHeight as a replacement for computed.height in IE, because IE does not account use of border-box
				var actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(computed.height)) : ta.offsetHeight;
	
				// The actual height not matching the style height (set via the resize method) indicates that
				// the max-height has been exceeded, in which case the overflow should be allowed.
				if (actualHeight !== styleHeight) {
					if (computed.overflowY === 'hidden') {
						changeOverflow('scroll');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				} else {
					// Normally keep overflow set to hidden, to avoid flash of scrollbar as the textarea expands.
					if (computed.overflowY !== 'hidden') {
						changeOverflow('hidden');
						resize();
						actualHeight = computed.boxSizing === 'content-box' ? Math.round(parseFloat(window.getComputedStyle(ta, null).height)) : ta.offsetHeight;
					}
				}
	
				if (cachedHeight !== actualHeight) {
					cachedHeight = actualHeight;
					var evt = createEvent('autosize:resized');
					try {
						ta.dispatchEvent(evt);
					} catch (err) {
						// Firefox will throw an error on dispatchEvent for a detached element
						// https://bugzilla.mozilla.org/show_bug.cgi?id=889376
					}
				}
			}
	
			var pageResize = function pageResize() {
				if (ta.clientWidth !== clientWidth) {
					update();
				}
			};
	
			var destroy = (function (style) {
				window.removeEventListener('resize', pageResize, false);
				ta.removeEventListener('input', update, false);
				ta.removeEventListener('keyup', update, false);
				ta.removeEventListener('autosize:destroy', destroy, false);
				ta.removeEventListener('autosize:update', update, false);
	
				Object.keys(style).forEach(function (key) {
					ta.style[key] = style[key];
				});
	
				map['delete'](ta);
			}).bind(ta, {
				height: ta.style.height,
				resize: ta.style.resize,
				overflowY: ta.style.overflowY,
				overflowX: ta.style.overflowX,
				wordWrap: ta.style.wordWrap
			});
	
			ta.addEventListener('autosize:destroy', destroy, false);
	
			// IE9 does not fire onpropertychange or oninput for deletions,
			// so binding to onkeyup to catch most of those events.
			// There is no way that I know of to detect something like 'cut' in IE9.
			if ('onpropertychange' in ta && 'oninput' in ta) {
				ta.addEventListener('keyup', update, false);
			}
	
			window.addEventListener('resize', pageResize, false);
			ta.addEventListener('input', update, false);
			ta.addEventListener('autosize:update', update, false);
			ta.style.overflowX = 'hidden';
			ta.style.wordWrap = 'break-word';
	
			map.set(ta, {
				destroy: destroy,
				update: update
			});
	
			init();
		}
	
		function destroy(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.destroy();
			}
		}
	
		function update(ta) {
			var methods = map.get(ta);
			if (methods) {
				methods.update();
			}
		}
	
		var autosize = null;
	
		// Do nothing in Node.js environment and IE8 (or lower)
		if (typeof window === 'undefined' || typeof window.getComputedStyle !== 'function') {
			autosize = function (el) {
				return el;
			};
			autosize.destroy = function (el) {
				return el;
			};
			autosize.update = function (el) {
				return el;
			};
		} else {
			autosize = function (el, options) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], function (x) {
						return assign(x, options);
					});
				}
				return el;
			};
			autosize.destroy = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], destroy);
				}
				return el;
			};
			autosize.update = function (el) {
				if (el) {
					Array.prototype.forEach.call(el.length ? el : [el], update);
				}
				return el;
			};
		}
	
		module.exports = autosize;
	});

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = floatLabelDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _autosize = __webpack_require__(13);
	
	var _autosize2 = _interopRequireDefault(_autosize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Applies the correct class names to the field.
	 *
	 * @param e - The event object
	 */
	function setState() {
	    var _this = this;
	
	    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var field = (0, _jquery2.default)(this);
	
	    // Wrap within an instantaneous timeout so state changes can be detected on the next redraw. This fixes a
	    // problem with the "keydown" event in that the key value is added to the field after the event has been
	    // called. This means the value of the field returned will be the previous value. The timeout ensures that
	    // the input happens before the value is checked.
	    setTimeout(function () {
	
	        // Enhance the file input by outputting information about the selected file
	        if (field.is('input[type="file"]')) {
	            var div = field.siblings('div');
	            var fileName = '';
	
	            if (_this.files && _this.files.length > 1) {
	                fileName = _this.files.length + ' files selected';
	            } else {
	                fileName = _this.value.split('\\').pop();
	            }
	
	            div.html(fileName);
	        }
	
	        field.closest('[sw-float-label]')
	
	        // Set the field type as a class to the float label wrapper
	        .addClass('-type-' + field.prop('tagName').toLowerCase())
	
	        // Is the element in focus?
	        .toggleClass('is-focused', e.type == 'focus' || field.is(':focus'))
	
	        // Check if the fields value is an empty string. This works for select options that have an empty
	        // value. This can be exploited by creating an empty option, disabling it and setting it as the
	        // default.
	        .toggleClass('is-filled', !!field.val())
	
	        // Only apply if browser supports field validation
	        .toggleClass('is-invalid', field[0].validity && !field[0].validity.valid)
	
	        // Specifically for textarea's. This is useful so that the label can be hidden when the content is
	        // scrolled, so that the label and the fields text don't overlap and look ugly.
	        .toggleClass('is-scrolled', field.scrollTop() > 0);
	    });
	}
	
	/**
	 * Adds float label behaviour to marked fields.
	 *
	 * @param context
	 */
	function floatLabelDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	
	    (0, _jquery2.default)(context).find('[sw-float-label]').find('input, select, textarea').on('focus blur change keyup keydown scroll', setState).each(setState);
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = validatorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Parsley library.
	 *
	 * @see http://parsleyjs.org/
	 * @type {string}
	 */
	var parsleyDir = 'https://cdnjs.cloudflare.com/ajax/libs/parsley.js/2.7.2/';
	
	function setFormEnabled($form, enabled) {
	    $form.find('input, select, textarea').prop('readonly', !enabled);
	    $form.find('button').prop('disabled', !enabled);
	}
	
	/**
	 * Enhances forms with live validation.
	 *
	 * @param context
	 */
	function validatorDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $forms = $context.find('form[sw-validator]');
	
	    // Only load Parsley if there are forms on the page
	    if ($forms.length > 0) {
	        (0, _request.dependency)(parsleyDir + 'parsley.min.js', function () {
	            return window.Parsley;
	        }).then(function () {
	            $forms.each(function () {
	                var $form = (0, _jquery2.default)(this);
	                var parsley = $form.parsley();
	
	                parsley.on('field:validated', function (_ref) {
	                    var $element = _ref.$element;
	
	                    // Make sure errors reported by the server get removed
	                    $element.siblings('.float-label_errors').remove();
	                });
	
	                parsley.on('form:submit', function (_ref2) {
	                    var $element = _ref2.$element;
	
	                    $element.addClass('is-posting');
	                    setFormEnabled($element, false);
	
	                    var target = $element.prop('target');
	                    var $iframe = target ? (0, _jquery2.default)('iframe[name="' + target + '"]') : (0, _jquery2.default)();
	
	                    $iframe.one('load', function (e) {
	                        $element.removeClass('is-posting');
	                        setFormEnabled($element, true);
	                    });
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.dependency = dependency;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Loads an external Javascript file and executes it.
	 *
	 * @param url - The URL to the Javascript file
	 * @param check - An optional function to return a boolean for manually checking if the script has correctly executed.
	 *   This ensures that the callback actually happens after the script has been executed. For example, if loading jQuery
	 *   this function could check whether the jQuery property exists on the window object.
	 * @return Promise
	 */
	var loadedDependencies = null;
	function dependency(url) {
	    var check = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
	        return true;
	    };
	    var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 10000;
	
	
	    if (!loadedDependencies) {
	        loadedDependencies = {};
	
	        // Add existing Javascript files as dependencies
	        // TODO Handle `defer` and `async`
	        (0, _jquery2.default)('script[src]').each(function () {
	            var src = (0, _jquery2.default)(this).prop('src');
	            loadedDependencies[src] = true;
	        });
	    }
	
	    return new Promise(function (resolve, reject) {
	
	        var startTime = Date.now();
	        function poll() {
	            if (check()) {
	                resolve();
	            } else if (Date.now() - startTime > timeout) {
	                reject();
	            } else {
	                setTimeout(poll, 50);
	            }
	        }
	
	        if (!loadedDependencies[url]) {
	            loadedDependencies[url] = true;
	            _jquery2.default.getScript(url).done(poll).fail(reject);
	        } else {
	            poll();
	        }
	    });
	}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = validatorDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var recaptchaPath = 'https://www.google.com/recaptcha/api.js';
	
	/**
	 * Enhances forms with Google reCAPTCHA functionality.
	 * Requires use of the reCAPTCHA Craft plugin.
	 *
	 * @param context
	 */
	function validatorDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
		var $forms = $context.find('form[sw-recaptcha]');
	
		// Only load reCAPTCHA API if there are forms on the page
		if ($forms.length > 0) {
			(0, _request.dependency)(recaptchaPath, function () {
	
				$forms.each(function () {
					var $form = (0, _jquery2.default)(this);
	
					var $recaptcha = $form.find('.g-recaptcha');
					var callbackName = $form.attr('sw-recaptcha');
					var formParsley = window.Parsley ? $form.parsley() : null;
	
					window[callbackName] = function () {
						// Removes all recaptcha event listeners so the recaptcha doesn't resend when resubmitting
						$recaptcha.replaceWith($recaptcha.clone());
	
						if (formParsley) {
							formParsley.whenValidate().then(function () {
								$form.submit();
							});
						}
					};
				});
			}, function () {
				return window.grecaptcha;
			});
		}
	}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = lightboxDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(16);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _data = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the PhotoSwipe library.
	 *
	 * @see http://photoswipe.com
	 * @type {string}
	 */
	var photoswipeDir = 'https://cdnjs.cloudflare.com/ajax/libs/photoswipe/4.1.2/';
	
	/**
	 * The reusable template for PhotoSwipe.
	 *
	 * @see http://photoswipe.com/documentation/getting-started.html
	 */
	var template = '\n    <div id="lightbox" class="pswp lightbox" tabindex="-1" role="dialog" aria-hidden="true">\n        <div class="pswp__bg"></div>\n        <div class="pswp__scroll-wrap">\n            <div class="pswp__container">\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n                <div class="pswp__item lightbox_item"></div>\n            </div>\n            <div class="pswp__ui pswp__ui--hidden">\n                <div class="pswp__top-bar">\n                    <div class="pswp__counter"></div>\n                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>\n                    <button class="pswp__button pswp__button--share" title="Share"></button>\n                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>\n                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>\n                    <div class="pswp__preloader">\n                        <div class="pswp__preloader__icn">\n                          <div class="pswp__preloader__cut">\n                            <div class="pswp__preloader__donut"></div>\n                          </div>\n                        </div>\n                    </div>\n                </div>\n                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">\n                    <div class="pswp__share-tooltip"></div>\n                </div>\n                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>\n                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>\n                <div class="pswp__caption">\n                    <div class="pswp__caption__center"></div>\n                </div>\n            </div>\n        </div>\n    </div>\n';
	
	/**
	 *
	 * @param element
	 * @returns {{}}
	 */
	function getConfigFromElement(element) {
	    // TODO
	    return {};
	}
	
	var initialised = false;
	var pswpElement = null;
	
	/**
	 * Initializes a PhotoSwipe gallery.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function lightboxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $lightboxes = $context.find('[sw-lightbox]');
	
	    if ($lightboxes.length > 0) {
	
	        if (!initialised) {
	            initialised = true;
	
	            (0, _jquery2.default)('head').append('\n                <link rel="stylesheet" href="' + photoswipeDir + 'photoswipe.min.css">\n                <link rel="stylesheet" href="' + photoswipeDir + 'default-skin/default-skin.min.css">\n            ');
	
	            (0, _jquery2.default)('body').append(template);
	
	            pswpElement = (0, _jquery2.default)('#lightbox')[0];
	        }
	
	        (0, _request.dependency)(photoswipeDir + 'photoswipe.min.js');
	        (0, _request.dependency)(photoswipeDir + 'photoswipe-ui-default.min.js', function () {
	            return window.PhotoSwipe && window.PhotoSwipeUI_Default;
	        }).then(function () {
	            var groups = {};
	
	            $lightboxes.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-lightbox');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    group: null,
	                    thumbnailUrl: '',
	                    html: '',
	                    url: '',
	                    width: 1280,
	                    height: 720,
	                    title: null
	                }, 'url');
	
	                settings.group = settings.group || (0, _data.uniqueId)();
	
	                if (!(settings.group in groups)) {
	                    groups[settings.group] = {
	                        elements: [],
	                        items: []
	                    };
	                }
	
	                var group = groups[settings.group];
	                var item = {
	                    msrc: settings.thumbnailUrl,
	                    w: settings.width | 0,
	                    h: settings.height | 0,
	                    title: settings.title
	                };
	
	                if (settings.html) {
	                    item.html = settings.html;
	                } else {
	                    item.src = settings.url;
	                }
	
	                group.elements.push(this);
	                group.items.push(item);
	
	                $element.on('click', function (e) {
	                    e.preventDefault();
	
	                    var options = {
	                        history: false,
	                        index: group.elements.indexOf(this),
	                        getThumbBoundsFn: function getThumbBoundsFn(index) {
	                            var $currentElement = (0, _jquery2.default)(group.elements[index]);
	                            var $thumb = $currentElement.is('[sw-lightbox-thumb]') ? $currentElement : $currentElement.find('[sw-lightbox-thumb]');
	                            var offset = $thumb.offset();
	                            var width = $thumb.width();
	                            var height = $thumb.height();
	
	                            // If the thumbnail has been letterboxed, this will get the correct width
	                            var trueWidth = Math.min(width, height / settings.height * settings.width);
	
	                            return offset ? {
	                                x: offset.left + (width - trueWidth) / 2,
	                                y: offset.top,
	                                w: trueWidth
	                            } : null;
	                        }
	                    };
	
	                    var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, group.items, options);
	                    gallery.init();
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 19 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.uniqueId = uniqueId;
	/**
	 * Generates a unique ID.
	 *
	 * @returns String
	 */
	var existingUniqueIds = {};
	function uniqueId() {
	    var range = Math.pow(10, 9);
	    var id = null;
	    while (!id || existingUniqueIds[id]) {
	        id = 'id' + (Math.random() * range | 0).toString(36);
	    }
	    existingUniqueIds[id] = true;
	    return id;
	}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = mapDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(16);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var mapsUrl = 'https://maps.googleapis.com/maps/api/js?libraries=geometry,places&key=AIzaSyBmAhgQndyyRTTqYJVZy3JaoC7n20Fvzfw';
	
	function mapDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $maps = (0, _jquery2.default)(context).find('[sw-map]');
	
	    if ($maps.length > 0) {
	
	        (0, _request.dependency)(mapsUrl).then(function () {
	            $maps.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-map');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    zoom: 15,
	                    draggable: false,
	                    markers: [],
	                    lat: 0,
	                    lng: 0
	                });
	
	                var mapOptions = {
	                    zoom: settings.zoom | 0,
	                    mapTypeId: google.maps.MapTypeId.ROADMAP,
	                    center: new google.maps.LatLng(settings.lat, settings.lng),
	                    scrollwheel: false,
	                    streetViewControl: false,
	                    draggable: settings.draggable,
	                    panControl: false,
	                    overviewMapControl: false,
	                    zoomControl: true,
	                    mapTypeControl: false,
	                    disableDefaultUI: true,
	                    disableDoubleClickZoom: true
	                };
	
	                var mapElement = $element[0];
	                var map = new google.maps.Map(mapElement, mapOptions);
	                var markers = [];
	
	                settings.markers.forEach(function (marker) {
	                    markers.push(new google.maps.Marker({
	                        position: new google.maps.LatLng(marker.lat, marker.lng),
	                        map: map
	                    }));
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = playOnHoverDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function playOnHoverDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $element = (0, _jquery2.default)(context).find('[sw-play-on-hover]');
	
	    $element.each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var $videos = $this.find('video');
	
	        $this.on('mouseenter', function () {
	            $videos.each(function () {
	                if (!this.ended || this.loop) {
	                    this.play();
	                }
	            });
	        }).on('mouseleave', function () {
	            $videos.each(function () {
	                this.pause();
	            });
	        });
	    });
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = swiperDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _request = __webpack_require__(16);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * The CDN directory of the Swiper library.
	 *
	 * @see http://idangero.us/swiper
	 * @type {string}
	 */
	var swiperDir = 'https://cdnjs.cloudflare.com/ajax/libs/Swiper/3.4.2/';
	
	var addedCss = false;
	
	/**
	 * Initializes a Swiper carousel.
	 *
	 * @see http://idangero.us/swiper
	 * @param context
	 */
	function swiperDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $swipers = $context.find('[sw-swiper]');
	
	    if ($swipers.length > 0) {
	
	        if (!addedCss) {
	            addedCss = true;
	            (0, _jquery2.default)('head').append('<link rel="stylesheet" href="' + swiperDir + 'css/swiper.min.css">');
	        }
	
	        (0, _request.dependency)(swiperDir + 'js/swiper.min.js', function () {
	            return window.Swiper;
	        }).then(function () {
	            $swipers.each(function () {
	                var $element = (0, _jquery2.default)(this);
	                var json = $element.attr('sw-swiper');
	                var settings = (0, _parse.directiveSettings)(json, {
	                    loop: true,
	                    preloadImages: false,
	                    lazyLoading: true,
	                    lazyLoadingInPrevNext: true,
	                    paginationElement: 'button',
	                    paginationClickable: true,
	                    runCallbacksOnInit: true
	                });
	
	                var $slides = $element.find('.swiper-slide');
	                var swiper = $slides.length > 1 ? new Swiper(this, settings) : false;
	
	                (0, _drawing.frame)(function () {
	                    return $element.addClass('swiper-ready');
	                });
	            });
	        });
	    }
	}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = fadeDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Fades an element out or in, the closer or farther it moves to or from the top of the window.
	 * Start fade-out once an element reaches 25% of the window height: <div sw-fade="0.25"></div>
	 * Start fade-out at 75% of the window height, and finish at 25%, based on the top position of the element:
	 * <div sw-fade='{"scroll": 0.5, "position": "top", "offset": 0.25}'></div>
	 *
	 * @param context
	 */
	function fadeDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	
	    $context.find('[sw-fade]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-fade');
	        var settings = (0, _parse.directiveSettings)(json, {
	            scroll: 0.25,
	            position: 'middle',
	            offset: 0
	        }, 'scroll');
	
	        (0, _window.onScroll)(function () {
	            var elementOffset = $element.offset().top - (0, _window.getHeight)() * settings.offset;
	            var elementHeight = $element.outerHeight();
	            var elementPosition = void 0;
	            switch (settings.position) {
	                case 'top':
	                    elementPosition = 0;break;
	                case 'bottom':
	                    elementPosition = elementHeight;break;
	                default:
	                    elementPosition = elementHeight / 2;break;
	            }
	            var contentPos = elementOffset + elementPosition - (0, _window.getScrollTop)();
	            var fadeHeight = (0, _window.getHeight)() * settings.scroll;
	            var opacity = contentPos / fadeHeight;
	            if (opacity < 0) {
	                opacity = 0;
	            } else if (opacity > 1) {
	                opacity = 1;
	            }
	            if (parseFloat($element.css('opacity')) !== opacity) {
	                $element.css('opacity', opacity);
	            }
	        });
	    });
	}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getProperties = getProperties;
	exports.getWidth = getWidth;
	exports.getHeight = getHeight;
	exports.getScrollTop = getScrollTop;
	exports.getScrollLeft = getScrollLeft;
	exports.getScrollWidth = getScrollWidth;
	exports.getScrollHeight = getScrollHeight;
	exports.onResize = onResize;
	exports.onScroll = onScroll;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _drawing = __webpack_require__(10);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	var properties = {};
	
	function updateDimensions() {
	  properties.width = $window.width();
	  properties.height = $window.height();
	}
	
	function updateScroll() {
	  properties.scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	  properties.scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft;
	  properties.scrollWidth = document.documentElement.scrollWidth || document.body.scrollWidth;
	  properties.scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
	}
	
	updateDimensions();
	updateScroll();
	
	$window.on('load resize', function () {
	  updateDimensions();updateScroll();
	});
	$window.on('scroll', function () {
	  updateScroll();
	});
	
	/**
	 * Returns all the above properties of the window object.
	 *
	 * @returns Object
	 */
	function getProperties() {
	  return Object.assign({}, properties);
	}
	
	/**
	 * Returns the width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getWidth() {
	  return properties.width;
	}
	
	/**
	 * Returns the height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getHeight() {
	  return properties.height;
	}
	
	/**
	 * Returns the top scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollTop() {
	  return properties.scrollTop;
	}
	
	/**
	 * Returns the left scroll value of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollLeft() {
	  return properties.scrollLeft;
	}
	
	/**
	 * Returns the scrollable width of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollWidth() {
	  return properties.scrollWidth;
	}
	
	/**
	 * Returns the scrollable height of the window in pixels.
	 *
	 * @returns Number
	 */
	function getScrollHeight() {
	  return properties.scrollHeight;
	}
	
	/**
	 * Binds a callback to resize events in a performant way.
	 * Returns a function that, when called, unbinds the events.
	 *
	 * @param callback
	 * @returns {Function}
	 */
	function onResize(callback) {
	  var currentFrame = void 0;
	  function debounce(e) {
	    (0, _drawing.unframe)(currentFrame);
	    currentFrame = (0, _drawing.frame)(function () {
	      return callback(e);
	    });
	  }
	
	  $window.on('load resize', debounce);
	
	  callback();
	
	  return function () {
	    return $window.off('load resize', debounce);
	  };
	}
	
	/**
	 * Binds a callback to scrolling events in a performant way.
	 * Returns a function that, when called, unbinds the events.
	 *
	 * @param callback
	 * @returns {Function}
	 */
	function onScroll(callback) {
	  var currentFrame = void 0;
	  function debounce(e) {
	    (0, _drawing.unframe)(currentFrame);
	    currentFrame = (0, _drawing.frame)(function () {
	      return callback(e);
	    });
	  }
	
	  $window.on('load resize scroll', debounce);
	
	  callback();
	
	  return function () {
	    return $window.off('load resize scroll', debounce);
	  };
	}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = lazyLoadDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _blazy = __webpack_require__(26);
	
	var _blazy2 = _interopRequireDefault(_blazy);
	
	var _data = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Lazily loads images, backgrounds, videos and iframes.
	 *
	 * @see http://dinbror.dk/blog/blazy/
	 * @param context
	 */
	function lazyLoadDirective() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var container = 'window';
	
		/*
	  * Problem:
	  *   Blazy library only supports a string selector for the container element.
	  *   This means that the `context` argument above cannot be passed directly as a DOM element to the Blazy
	  *   initialisation function.
	  *
	  * Solution:
	  *   Generate a unique attribute for the element, add it to the element, then use a selector targeting that
	  *   attribute.
	  */
		if (context !== document.body) {
			var uniqueAttr = 'data-' + (0, _data.uniqueId)();
			container = '[' + uniqueAttr + ']';
	
			(0, _jquery2.default)(context).attr(uniqueAttr, true);
		}
	
		var blazy = new _blazy2.default({
			container: container,
			selector: '[sw-lazy-load]',
			src: 'sw-lazy-load',
			successClass: 'is-ready',
			errorClass: 'is-broken',
			success: function success() {
				return blazy.revalidate();
			}
		});
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  hey, [be]Lazy.js - v1.8.2 - 2016.10.25
	  A fast, small and dependency free lazy load script (https://github.com/dinbror/blazy)
	  (c) Bjoern Klinggaard - @bklinggaard - http://dinbror.dk/blazy
	*/
	;
	(function(root, blazy) {
	    if (true) {
	        // AMD. Register bLazy as an anonymous module
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (blazy), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = blazy();
	    } else {
	        // Browser globals. Register bLazy on window
	        root.Blazy = blazy();
	    }
	})(this, function() {
	    'use strict';
	
	    //private vars
	    var _source, _viewport, _isRetina, _supportClosest, _attrSrc = 'src', _attrSrcset = 'srcset';
	
	    // constructor
	    return function Blazy(options) {
	        //IE7- fallback for missing querySelectorAll support
	        if (!document.querySelectorAll) {
	            var s = document.createStyleSheet();
	            document.querySelectorAll = function(r, c, i, j, a) {
	                a = document.all, c = [], r = r.replace(/\[for\b/gi, '[htmlFor').split(',');
	                for (i = r.length; i--;) {
	                    s.addRule(r[i], 'k:v');
	                    for (j = a.length; j--;) a[j].currentStyle.k && c.push(a[j]);
	                    s.removeRule(0);
	                }
	                return c;
	            };
	        }
	
	        //options and helper vars
	        var scope = this;
	        var util = scope._util = {};
	        util.elements = [];
	        util.destroyed = true;
	        scope.options = options || {};
	        scope.options.error = scope.options.error || false;
	        scope.options.offset = scope.options.offset || 100;
	        scope.options.root = scope.options.root || document;
	        scope.options.success = scope.options.success || false;
	        scope.options.selector = scope.options.selector || '.b-lazy';
	        scope.options.separator = scope.options.separator || '|';
	        scope.options.containerClass = scope.options.container;
	        scope.options.container = scope.options.containerClass ? document.querySelectorAll(scope.options.containerClass) : false;
	        scope.options.errorClass = scope.options.errorClass || 'b-error';
	        scope.options.breakpoints = scope.options.breakpoints || false;
	        scope.options.loadInvisible = scope.options.loadInvisible || false;
	        scope.options.successClass = scope.options.successClass || 'b-loaded';
	        scope.options.validateDelay = scope.options.validateDelay || 25;
	        scope.options.saveViewportOffsetDelay = scope.options.saveViewportOffsetDelay || 50;
	        scope.options.srcset = scope.options.srcset || 'data-srcset';
	        scope.options.src = _source = scope.options.src || 'data-src';
	        _supportClosest = Element.prototype.closest;
	        _isRetina = window.devicePixelRatio > 1;
	        _viewport = {};
	        _viewport.top = 0 - scope.options.offset;
	        _viewport.left = 0 - scope.options.offset;
	
	
	        /* public functions
	         ************************************/
	        scope.revalidate = function() {
	            initialize(scope);
	        };
	        scope.load = function(elements, force) {
	            var opt = this.options;
	            if (elements && elements.length === undefined) {
	                loadElement(elements, force, opt);
	            } else {
	                each(elements, function(element) {
	                    loadElement(element, force, opt);
	                });
	            }
	        };
	        scope.destroy = function() {            
	            var util = scope._util;
	            if (scope.options.container) {
	                each(scope.options.container, function(object) {
	                    unbindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            unbindEvent(window, 'scroll', util.validateT);
	            unbindEvent(window, 'resize', util.validateT);
	            unbindEvent(window, 'resize', util.saveViewportOffsetT);
	            util.count = 0;
	            util.elements.length = 0;
	            util.destroyed = true;
	        };
	
	        //throttle, ensures that we don't call the functions too often
	        util.validateT = throttle(function() {
	            validate(scope);
	        }, scope.options.validateDelay, scope);
	        util.saveViewportOffsetT = throttle(function() {
	            saveViewportOffset(scope.options.offset);
	        }, scope.options.saveViewportOffsetDelay, scope);
	        saveViewportOffset(scope.options.offset);
	
	        //handle multi-served image src (obsolete)
	        each(scope.options.breakpoints, function(object) {
	            if (object.width >= window.screen.width) {
	                _source = object.src;
	                return false;
	            }
	        });
	
	        // start lazy load
	        setTimeout(function() {
	            initialize(scope);
	        }); // "dom ready" fix
	
	    };
	
	
	    /* Private helper functions
	     ************************************/
	    function initialize(self) {
	        var util = self._util;
	        // First we create an array of elements to lazy load
	        util.elements = toArray(self.options);
	        util.count = util.elements.length;
	        // Then we bind resize and scroll events if not already binded
	        if (util.destroyed) {
	            util.destroyed = false;
	            if (self.options.container) {
	                each(self.options.container, function(object) {
	                    bindEvent(object, 'scroll', util.validateT);
	                });
	            }
	            bindEvent(window, 'resize', util.saveViewportOffsetT);
	            bindEvent(window, 'resize', util.validateT);
	            bindEvent(window, 'scroll', util.validateT);
	        }
	        // And finally, we start to lazy load.
	        validate(self);
	    }
	
	    function validate(self) {
	        var util = self._util;
	        for (var i = 0; i < util.count; i++) {
	            var element = util.elements[i];
	            if (elementInView(element, self.options) || hasClass(element, self.options.successClass)) {
	                self.load(element);
	                util.elements.splice(i, 1);
	                util.count--;
	                i--;
	            }
	        }
	        if (util.count === 0) {
	            self.destroy();
	        }
	    }
	
	    function elementInView(ele, options) {
	        var rect = ele.getBoundingClientRect();
	
	        if(options.container && _supportClosest){
	            // Is element inside a container?
	            var elementContainer = ele.closest(options.containerClass);
	            if(elementContainer){
	                var containerRect = elementContainer.getBoundingClientRect();
	                // Is container in view?
	                if(inView(containerRect, _viewport)){
	                    var top = containerRect.top - options.offset;
	                    var right = containerRect.right + options.offset;
	                    var bottom = containerRect.bottom + options.offset;
	                    var left = containerRect.left - options.offset;
	                    var containerRectWithOffset = {
	                        top: top > _viewport.top ? top : _viewport.top,
	                        right: right < _viewport.right ? right : _viewport.right,
	                        bottom: bottom < _viewport.bottom ? bottom : _viewport.bottom,
	                        left: left > _viewport.left ? left : _viewport.left
	                    };
	                    // Is element in view of container?
	                    return inView(rect, containerRectWithOffset);
	                } else {
	                    return false;
	                }
	            }
	        }      
	        return inView(rect, _viewport);
	    }
	
	    function inView(rect, viewport){
	        // Intersection
	        return rect.right >= viewport.left &&
	               rect.bottom >= viewport.top && 
	               rect.left <= viewport.right && 
	               rect.top <= viewport.bottom;
	    }
	
	    function loadElement(ele, force, options) {
	        // if element is visible, not loaded or forced
	        if (!hasClass(ele, options.successClass) && (force || options.loadInvisible || (ele.offsetWidth > 0 && ele.offsetHeight > 0))) {
	            var dataSrc = getAttr(ele, _source) || getAttr(ele, options.src); // fallback to default 'data-src'
	            if (dataSrc) {
	                var dataSrcSplitted = dataSrc.split(options.separator);
	                var src = dataSrcSplitted[_isRetina && dataSrcSplitted.length > 1 ? 1 : 0];
	                var srcset = getAttr(ele, options.srcset);
	                var isImage = equal(ele, 'img');
	                var parent = ele.parentNode;
	                var isPicture = parent && equal(parent, 'picture');
	                // Image or background image
	                if (isImage || ele.src === undefined) {
	                    var img = new Image();
	                    // using EventListener instead of onerror and onload
	                    // due to bug introduced in chrome v50 
	                    // (https://productforums.google.com/forum/#!topic/chrome/p51Lk7vnP2o)
	                    var onErrorHandler = function() {
	                        if (options.error) options.error(ele, "invalid");
	                        addClass(ele, options.errorClass);
	                        unbindEvent(img, 'error', onErrorHandler);
	                        unbindEvent(img, 'load', onLoadHandler);
	                    };
	                    var onLoadHandler = function() {
	                        // Is element an image
	                        if (isImage) {
	                            if(!isPicture) {
	                                handleSources(ele, src, srcset);
	                            }
	                        // or background-image
	                        } else {
	                            ele.style.backgroundImage = 'url("' + src + '")';
	                        }
	                        itemLoaded(ele, options);
	                        unbindEvent(img, 'load', onLoadHandler);
	                        unbindEvent(img, 'error', onErrorHandler);
	                    };
	                    
	                    // Picture element
	                    if (isPicture) {
	                        img = ele; // Image tag inside picture element wont get preloaded
	                        each(parent.getElementsByTagName('source'), function(source) {
	                            handleSource(source, _attrSrcset, options.srcset);
	                        });
	                    }
	                    bindEvent(img, 'error', onErrorHandler);
	                    bindEvent(img, 'load', onLoadHandler);
	                    handleSources(img, src, srcset); // Preload
	
	                } else { // An item with src like iframe, unity games, simpel video etc
	                    ele.src = src;
	                    itemLoaded(ele, options);
	                }
	            } else {
	                // video with child source
	                if (equal(ele, 'video')) {
	                    each(ele.getElementsByTagName('source'), function(source) {
	                        handleSource(source, _attrSrc, options.src);
	                    });
	                    ele.load();
	                    itemLoaded(ele, options);
	                } else {
	                    if (options.error) options.error(ele, "missing");
	                    addClass(ele, options.errorClass);
	                }
	            }
	        }
	    }
	
	    function itemLoaded(ele, options) {
	        addClass(ele, options.successClass);
	        if (options.success) options.success(ele);
	        // cleanup markup, remove data source attributes
	        removeAttr(ele, options.src);
	        removeAttr(ele, options.srcset);
	        each(options.breakpoints, function(object) {
	            removeAttr(ele, object.src);
	        });
	    }
	
	    function handleSource(ele, attr, dataAttr) {
	        var dataSrc = getAttr(ele, dataAttr);
	        if (dataSrc) {
	            setAttr(ele, attr, dataSrc);
	            removeAttr(ele, dataAttr);
	        }
	    }
	
	    function handleSources(ele, src, srcset){
	        if(srcset) {
	            setAttr(ele, _attrSrcset, srcset); //srcset
	        }
	        ele.src = src; //src 
	    }
	
	    function setAttr(ele, attr, value){
	        ele.setAttribute(attr, value);
	    }
	
	    function getAttr(ele, attr) {
	        return ele.getAttribute(attr);
	    }
	
	    function removeAttr(ele, attr){
	        ele.removeAttribute(attr); 
	    }
	
	    function equal(ele, str) {
	        return ele.nodeName.toLowerCase() === str;
	    }
	
	    function hasClass(ele, className) {
	        return (' ' + ele.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    }
	
	    function addClass(ele, className) {
	        if (!hasClass(ele, className)) {
	            ele.className += ' ' + className;
	        }
	    }
	
	    function toArray(options) {
	        var array = [];
	        var nodelist = (options.root).querySelectorAll(options.selector);
	        for (var i = nodelist.length; i--; array.unshift(nodelist[i])) {}
	        return array;
	    }
	
	    function saveViewportOffset(offset) {
	        _viewport.bottom = (window.innerHeight || document.documentElement.clientHeight) + offset;
	        _viewport.right = (window.innerWidth || document.documentElement.clientWidth) + offset;
	    }
	
	    function bindEvent(ele, type, fn) {
	        if (ele.attachEvent) {
	            ele.attachEvent && ele.attachEvent('on' + type, fn);
	        } else {
	            ele.addEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function unbindEvent(ele, type, fn) {
	        if (ele.detachEvent) {
	            ele.detachEvent && ele.detachEvent('on' + type, fn);
	        } else {
	            ele.removeEventListener(type, fn, { capture: false, passive: true });
	        }
	    }
	
	    function each(object, fn) {
	        if (object && fn) {
	            var l = object.length;
	            for (var i = 0; i < l && fn(object[i], i) !== false; i++) {}
	        }
	    }
	
	    function throttle(fn, minDelay, scope) {
	        var lastCall = 0;
	        return function() {
	            var now = +new Date();
	            if (now - lastCall < minDelay) {
	                return;
	            }
	            lastCall = now;
	            fn.apply(scope, arguments);
	        };
	    }
	});


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = parallaxDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _drawing = __webpack_require__(10);
	
	var _window = __webpack_require__(24);
	
	var _parse = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Adds parallax to an element.
	 *
	 * Parallax with 75% speed: <div sw-parallax="0.75"></div>
	 * Parallax for background images: <div sw-parallax='{"scale": true}'></div>
	 *
	 * @param context
	 */
	function parallaxDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-parallax]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-parallax');
	        var settings = (0, _parse.directiveSettings)(json, {
	            speed: 0.5,
	            align: 0.5,
	            target: false,
	            scale: false
	        }, 'speed');
	
	        var $target = settings.target && !settings.scale ? (0, _jquery2.default)(settings.target) : false;
	
	        var height = void 0;
	        var offset = void 0;
	        var transform = void 0;
	
	        function setup() {
	            $element.css('transform', '');
	            $element.css('transform-origin', 'top center');
	
	            (0, _drawing.redraw)($element);
	
	            height = $element.outerHeight();
	            offset = $element.offset();
	
	            if (settings.scale) {
	                var viewHeight = Math.min((0, _window.getHeight)(), offset.top + height);
	                var newHeight = viewHeight - (viewHeight - height) * settings.speed;
	                transform = 'scale(' + newHeight / height + ')';
	            } else {
	                transform = '';
	            }
	
	            position();
	        }
	
	        function position() {
	            var targetHeight = $target ? $target.height() : (0, _window.getHeight)();
	            var scaleOffset = (targetHeight - height) * settings.align;
	            var translate = ((0, _window.getScrollTop)() - offset.top + scaleOffset) * (settings.speed - 1);
	
	            $element.css('transform', 'translate3d(0, ' + -translate + 'px, 0) ' + transform);
	        }
	
	        setup();
	        (0, _jquery2.default)(function () {
	            return (0, _drawing.frame)(setup);
	        });
	        $window.on('load resize', function () {
	            return (0, _drawing.frame)(setup);
	        });
	        $window.on('scroll', function () {
	            return (0, _drawing.frame)(position);
	        });
	    });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = revealDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _inspection = __webpack_require__(29);
	
	var _drawing = __webpack_require__(10);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $window = (0, _jquery2.default)(window);
	
	function revealDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $reveal = $context.find('[sw-reveal]');
	
	    if (!(0, _inspection.isTouch)()) {
	        var checkForReveal = function checkForReveal(element) {
	            var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	            var $this = (0, _jquery2.default)(element);
	            var isScrolled = $window.scrollTop() + $window.outerHeight() > $this.offset().top;
	            if (isScrolled && !$this.hasClass('is-revealed')) {
	                $this.addClass('is-revealed');
	            } else if (reset && !isScrolled && $this.hasClass('is-revealed')) {
	                $this.removeClass('is-revealed');
	            }
	        };
	
	        $reveal.each(function () {
	            var $element = (0, _jquery2.default)(this);
	            var json = $element.attr('sw-reveal');
	            var settings = (0, _parse.directiveSettings)(json, {
	                force: false,
	                reset: true
	            }, 'force');
	
	            if (!settings.force) {
	                $element.css('transition', 'none');
	            }
	
	            checkForReveal($element, settings.reset);
	
	            if (!settings.force) {
	                (0, _drawing.frame)(function () {
	                    return $element.css('transition', '');
	                });
	            }
	
	            (0, _window.onScroll)(function () {
	                return checkForReveal($element, settings.reset);
	            });
	        });
	    } else {
	
	        $reveal.css('transition', 'none');
	        $reveal.addClass('is-revealed');
	    }
	}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.isTouch = isTouch;
	exports.isIE = isIE;
	exports.isSafari = isSafari;
	/**
	 * Crude check to see if the device is a touch screen.
	 * @see http://stackoverflow.com/a/4819886/556609
	 *
	 * @returns {boolean}
	 */
	function isTouch() {
	    return 'ontouchstart' in window || !!navigator.maxTouchPoints;
	}
	
	/**
	 * Crude check to see if the browser is IE.
	 *
	 * @param version - Optionally check a specific version (11, 10, or 9)
	 * @returns {boolean}
	 */
	function isIE() {
	    var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
	
	    var ua = navigator.userAgent;
	    var is11 = /rv:11\.0/i.test(ua);
	    var is10 = /MSIE 10/i.test(ua);
	    var is9 = /MSIE 9/i.test(ua);
	
	    switch (version) {
	        case 11:
	            return is11;
	        case 10:
	            return is10;
	        case 9:
	            return is9;
	    }
	
	    return is11 && is10 && is9;
	}
	
	/**
	 * Crude check to see if the browser is Safari.
	 *
	 * @returns {boolean}
	 */
	function isSafari() {
	    return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	    );
	}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = stickyDirective;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _parse = __webpack_require__(6);
	
	var _window = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Sticks an element top the top of the screen.
	 * TODO Allow for a sticky container to stop elements sticking too far.
	 *
	 * @param context
	 */
	function stickyDirective() {
	    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
	    var $context = (0, _jquery2.default)(context);
	    var $window = (0, _jquery2.default)(window);
	
	    $context.find('[sw-sticky]').each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var json = $element.attr('sw-sticky');
	        var settings = (0, _parse.directiveSettings)(json, {
	            name: '',
	            offset: 0
	        }, 'name');
	
	        var $filler = settings.name ? $context.find('[sw-sticky-filler=\'' + settings.name + '\']') : (0, _jquery2.default)();
	        if ($filler.length === 0) {
	            $filler = (0, _jquery2.default)('<div sw-sticky-filler="' + settings.name + '">');
	            $element.before($filler);
	        }
	
	        var isFixed = false;
	
	        function fillerSize() {
	            $filler.css('height', $element.outerHeight() + 'px');
	        }
	
	        function stickyScroll() {
	            if (isFixed) {
	                var fillerTop = $filler.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() <= fillerTop) {
	                    isFixed = false;
	                    fixSticky(false);
	                }
	            } else {
	                var stickyTop = $element.offset().top + settings.offset;
	                if ((0, _window.getScrollTop)() > stickyTop) {
	                    isFixed = true;
	                    fixSticky(true);
	                }
	            }
	        }
	
	        function fixSticky(fix) {
	            if (fix) {
	                $filler.css('display', '');
	                $element.addClass('is-stuck').removeClass('is-unstuck');
	            } else {
	                $filler.css('display', 'none');
	                $element.removeClass('is-stuck').addClass('is-unstuck');
	            }
	        }
	
	        fillerSize();
	        fixSticky(false);
	        stickyScroll();
	
	        $window.on('resize', fillerSize);
	        $window.on('resize scroll', stickyScroll);
	    });
	}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = headerSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _window = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function headerSection() {
		var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
	
		var $context = (0, _jquery2.default)(context);
		var $parents = (0, _jquery2.default)('#header-nav .-parent');
	
		(0, _jquery2.default)('[href="/#"]').click(function (e) {
			e.preventDefault();
		});
	
		$parents.each(function () {
			var $this = (0, _jquery2.default)(this);
			var $a = $this.find('> a');
	
			$a.click(function (e) {
				if ((0, _window.getWidth)() < 1080) {
					e.preventDefault();
					var sub = $this.find('> ul');
					sub.slideToggle(500);
					$this.toggleClass('-active');
				}
			});
		});
	}

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = popupSection;
	
	var _jquery = __webpack_require__(3);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function popupSection() {
		var POPUP = (0, _jquery2.default)('.popup');
	
		if (POPUP.length) {
			var close = POPUP.find('.popup_close');
	
			close.click(function () {
				POPUP.addClass('+hidden');
			});
	
			if (!sessionStorage.getItem('shownPopup')) {
				setTimeout(function () {
					POPUP.removeClass('+hidden');
				}, 1000);
	
				sessionStorage.setItem('shownPopup', 'yes');
			}
		}
	}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// main.js